(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wtpb-form-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const observed = new WeakSet();
  function repairLabels(root) {
    root.querySelectorAll('label[for]').forEach(label => {
      const name = label.getAttribute('for');
      const field = Array.from(label.parentElement.querySelectorAll('textarea'))
        .find(input => input.name === name && !input.id);
      if (field && !root.getElementById(name)) field.id = name;
    });
  }
  function connect() {
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);
      repairLabels(root);
      new MutationObserver(() => repairLabels(root))
        .observe(root, {childList: true, subtree: true});
    });
  }
  new MutationObserver(connect).observe(document.body, {childList: true, subtree: true});
  customElements.whenDefined('shopify-forms-embed').then(connect);
  connect();
  let attempts = 0;
  const timer = window.setInterval(() => {
    connect();
    if (++attempts >= 50) window.clearInterval(timer);
  }, 200);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-google-review-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = { enabled: true, apiKey: 'AIzaSyA54zpQ2m3alkOxIcGE-3HUvte49j6AA90', placeId: 'ChIJVR_nN-OaFo8R4D77HDGAP1Q' };
    if (!config.enabled || !config.apiKey || !config.placeId) return;
    let pending;
    function loadPlaces() {
      if (window.google?.maps?.importLibrary) return window.google.maps.importLibrary('places');
      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Google unavailable')), 12000);
        window.wtpbGoogleReviewsReady = () => {
          clearTimeout(timeout);
          window.google.maps.importLibrary('places').then(resolve, reject);
        };
        const script = document.createElement('script');
        const url = new URL('https://maps.googleapis.com/maps/api/js');
        url.search = new URLSearchParams({key:config.apiKey, v:'quarterly', loading:'async', callback:'wtpbGoogleReviewsReady'});
        script.src = url.href;
        script.async = true;
        script.onerror = () => { clearTimeout(timeout); reject(new Error('Google unavailable')); };
        document.head.append(script);
      });
    }
    function getReviews() {
      if (!pending) pending = (async () => {
        const { Place } = await loadPlaces();
        const place = new Place({id:config.placeId});
        await place.fetchFields({fields:['rating','userRatingCount','googleMapsURI','attributions']});
        if (!Number.isInteger(place.userRatingCount) || place.userRatingCount < 0) throw new Error('No count');
        if (place.userRatingCount > 0 && (!Number.isFinite(place.rating) || place.rating < 1 || place.rating > 5)) throw new Error('No rating');
        return place;
      })();
      return pending;
    }
    async function update(root) {
      try {
        const place = await getReviews();
        root.dataset.googleStatus = 'ready';
        const link = root.querySelector('.wtpb-google-summary__link');
        if (place.googleMapsURI) {
          const url = new URL(place.googleMapsURI);
          if (url.protocol === 'https:' && /(^|\.)google\.com$/.test(url.hostname)) link.href = url.href;
        }
        if (place.userRatingCount) link.setAttribute('aria-label', root.dataset.googleLabel.replace('__RATING__', place.rating.toFixed(1)).replace('__COUNT__', place.userRatingCount.toLocaleString()));
        const rating = root.querySelector('[data-google-rating]');
        rating.textContent = place.userRatingCount ? place.rating.toFixed(1) : '';
        root.querySelector('[data-google-star]').hidden = !place.userRatingCount;
        root.querySelector('[data-google-count]').textContent = place.userRatingCount.toLocaleString();
        const credit = root.querySelector('[data-google-attributions]');
        for (const attribution of place.attributions || []) {
          const item = document.createElement('a');
          item.textContent = attribution.provider || '';
          if (attribution.providerURI) {
            try {
              const url = new URL(attribution.providerURI);
              if (url.protocol === 'https:' || url.protocol === 'http:') item.href = url.href;
            } catch (_) {}
          }
          item.target = '_blank';
          item.rel = 'noopener';
          credit.append(item, ' ');
        }
        root.querySelector('[data-google-fallback]').hidden = true;
        root.querySelector('[data-google-result]').hidden = false;
      } catch (_) {
        root.dataset.googleStatus = 'unavailable';
      }
    }
    const roots = document.querySelectorAll('[data-wtpb-google-summary]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          update(entry.target);
        }
      });
      roots.forEach(root => observer.observe(root));
    } else roots.forEach(update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-primary-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(nav) {
    if (nav.dataset.initialized) return;
    nav.dataset.initialized = 'true';
    const groups = [...nav.querySelectorAll('details')];
    const closeAll = () => groups.forEach(group => { group.open = false; });
    groups.forEach(group => {
      group.addEventListener('toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      });
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape' && group.open) {
          event.preventDefault();
          group.open = false;
          group.querySelector('summary').focus();
        }
        if (event.key === 'ArrowDown' && event.target.tagName === 'SUMMARY') {
          event.preventDefault();
          group.open = true;
          group.querySelector('a')?.focus();
        }
      });
      group.addEventListener('focusout', () => {
        setTimeout(() => { if (!group.contains(document.activeElement)) group.open = false; }, 0);
      });
    });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) closeAll(); });
    window.addEventListener('resize', closeAll);
  }
  document.querySelectorAll('.wtpb-shopnav').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.wtpb-shopnav').forEach(initialize));
})();

(() => {
  const triggerSelector = '.js-mobile-menu-icon';
  const drawerSelector = '.header-navigation';
  const panelSelector = '.navigation__container';
  function updateControls() {
    const drawer = document.querySelector(drawerSelector);
    const panel = drawer?.querySelector(panelSelector);
    if (!panel) return;
    panel.id = panel.id || 'wtpb-menu-drawer';
    const open = drawer.classList.contains('header-navigation--open');
    document.querySelectorAll(triggerSelector).forEach(button => {
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', String(open));
    });
  }
  function setOpen(open, restoreFocus) {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;
    drawer.classList.toggle('header-navigation--open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    updateControls();
    if (!open && restoreFocus) document.querySelector(triggerSelector)?.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;
    const open = drawer.classList.contains('header-navigation--open');
    if (target.closest(triggerSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(!open, false);
      return;
    }
    if (target.closest('.js-close-mobile-menu')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(false, true);
      return;
    }
    if (open && !drawer.querySelector(panelSelector)?.contains(target)) setOpen(false, false);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector(drawerSelector)?.classList.contains('header-navigation--open')) {
      event.preventDefault();
      setOpen(false, true);
    }
  });
  const routeLabel = document.querySelector('[data-wtx-route-nav-label]')?.dataset.wtxRouteNavLabel;
  if (routeLabel) document.querySelectorAll('.header-navigation a, .customer-account__menu a').forEach(link => {
    if (link.getAttribute('href') === '/pages/delivery-routes' && !link.querySelector('svg')) link.textContent = routeLabel;
  });
  updateControls();
  document.addEventListener('shopify:section:load', updateControls);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-subscription-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!/^\/a\/subscriptions\/manage\//.test(location.pathname)) return;
  const copyElement = document.getElementById('wtpb-subscription-copy');
  if (!copyElement || !window.HTMLDialogElement) return;
  let copy;
  try { copy = JSON.parse(copyElement.textContent); } catch (_) { return; }
  const initialized = new WeakSet();
  let instanceCount = 0;
  const rowSelector = '[data-billing-attempt-id]';
  const skipSelector = '.seal-edit-button[data-action="skip"][data-id]';
  const scheduleSelector = '.seal-edit-button[data-action="reschedule"][data-time][data-id],.seal-edit-button[data-action="reschedule-and-reset"][data-time][data-id]';
  const dateText = value => new Intl.DateTimeFormat(document.documentElement.lang || undefined, { dateStyle:'long',timeStyle:'short' }).format(new Date(value));
  const fill = (value, date) => String(value).replace('__date__', date);
  const visible = element => {
    if (!element || !element.isConnected || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && !element.closest('[hidden]');
  };
  const enabled = element => !element.matches('[disabled],[aria-disabled="true"],.seal-button-disabled,.seal-loading') && !element.closest('[aria-disabled="true"]');
  const candidates = root => {
    if (Array.from(root.querySelectorAll('.seal-cancelled-status-label,.seal-paused-status-label')).some(visible)) return [];
    if (Array.from(root.querySelectorAll('#seal-resume-button,#seal-reactivate-button')).some(visible)) return [];
    const rows = Array.from(root.querySelectorAll(rowSelector));
    const skippedIds = new Set(rows.filter(row => row.getAttribute('data-billing-attempt-skip')).map(row => row.getAttribute('data-billing-attempt-id')));
    const byId = new Map();
    const unknown = [];
    let conflicting = false;
    rows.forEach((row,index) => {
      if (row.getAttribute('data-billing-attempt-skip')) return;
      const futureFlag = row.getAttribute('data-billing-attempt-in-the-future');
      if (futureFlag !== null && futureFlag !== 'true') return;
      const id = row.getAttribute('data-billing-attempt-id');
      const target = row.querySelector(skipSelector);
      const schedule = row.querySelector(scheduleSelector);
      if (skippedIds.has(id)) return;
      const rawTime = schedule && schedule.getAttribute('data-time');
      const time = Date.parse(rawTime);
      if (!id || !schedule || schedule.getAttribute('data-id') !== id || !Number.isFinite(time)) {
        if (visible(row) && (target || schedule)) unknown.push({index,time});
        return;
      }
      if (time <= Date.now()) return;
      const dateElement = row.querySelector('[data-convert-time]');
      const label = dateElement && dateElement.textContent.trim();
      const canSkip = Boolean(label && target && target.getAttribute('data-id') === id && visible(row) && visible(dateElement) && visible(target) && enabled(target));
      const previous = byId.get(id);
      if (previous && previous.time !== time) { conflicting = true;return; }
      const record = { row,target,id,rawTime,time,index:previous?Math.min(previous.index,index):index,canSkip,label:label || dateText(time) };
      if (!previous || (!previous.canSkip && canSkip)) byId.set(id,record);
    });
    if (conflicting) return [];
    const records = Array.from(byId.values());
    records.sort((a,b) => a.time - b.time);
    if (!records.length) return [];
    if (records.length > 1 && records[0].time === records[1].time && records[0].id !== records[1].id) return [];
    if (!records[0].canSkip || unknown.some(row => Number.isFinite(row.time) ? row.time > Date.now() && row.time <= records[0].time : row.index < records[0].index)) return [];
    return [records[0]];
  };
  const mount = () => {
    document.querySelectorAll('.seal-subscription-page').forEach(root => {
      if (initialized.has(root)) return;
      const action = root.querySelector('#seal-pause-button,#seal-unsubscribe-button');
      const anchor = (action && action.closest('.seal-dynamic-sectioned')) || root.querySelector('.seal-dynamic-sectioned');
      if (!anchor) return;
      initialized.add(root);
      const instanceId = 'wtpb-subscription-controls-' + (++instanceCount);
      const card = document.createElement('section');
      card.className = 'wtpb-subscription-control';
      card.id = instanceId;
      card.dataset.wtpbState = 'unavailable';
      card.hidden = true;
      card.setAttribute('aria-labelledby',instanceId + '-title');
      const heading = document.createElement('h2');
      heading.id = instanceId + '-title';
      heading.textContent = copy.heading;
      const description = document.createElement('p');
      description.textContent = copy.description;
      const next = document.createElement('p');
      next.className = 'wtpb-subscription-control__date';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wtpb-subscription-control__primary';
      button.textContent = copy.skip;
      const status = document.createElement('p');
      status.className = 'wtpb-subscription-control__status';
      status.setAttribute('role','status');
      status.setAttribute('aria-live','polite');
      status.hidden = true;
      const review = document.createElement('button');
      review.type = 'button';
      review.className = 'wtpb-subscription-control__secondary';
      review.textContent = copy.review;
      review.hidden = true;
      card.append(heading,description,next,button,status,review);
      anchor.before(card);
      const dialog = document.createElement('dialog');
      dialog.className = 'wtpb-subscription-dialog';
      dialog.setAttribute('aria-labelledby',instanceId + '-dialog-title');
      dialog.setAttribute('aria-describedby',instanceId + '-dialog-description');
      const dialogTitle = document.createElement('h2');
      dialogTitle.id = instanceId + '-dialog-title';
      const dialogDescription = document.createElement('p');
      dialogDescription.id = instanceId + '-dialog-description';
      const confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'wtpb-subscription-control__primary';
      confirm.textContent = copy.confirm;
      const keep = document.createElement('button');
      keep.type = 'button';
      keep.className = 'wtpb-subscription-control__secondary';
      keep.textContent = copy.keep;
      dialog.append(dialogTitle,dialogDescription,confirm,keep);
      card.append(dialog);
      let selected = null;
      let pending = null;
      let completed = false;
      let uncertain = false;
      let timeout;
      let scheduled = false;
      const announce = message => { status.textContent = message; status.hidden = false; };
      const closeDialog = () => { if (dialog.open) dialog.close(); selected = null; };
      const fail = message => {
        clearTimeout(timeout);
        pending = null;
        uncertain = true;
        card.dataset.wtpbState = 'unconfirmed';
        button.disabled = true;
        confirm.disabled = false;
        closeDialog();
        announce(message);
        review.hidden = false;
      };
      const refresh = () => {
        if (!root.isConnected) { observer.disconnect();clearTimeout(timeout);return; }
        if (pending) {
          if (!pending.row.isConnected || pending.row.getAttribute('data-billing-attempt-id') !== pending.id || pending.target.getAttribute('data-id') !== pending.id || pending.row.querySelector(scheduleSelector)?.getAttribute('data-time') !== pending.rawTime) { fail(copy.changed);return; }
          if (pending.row.getAttribute('data-billing-attempt-skip')) {
            clearTimeout(timeout);
            completed = true;
            pending = null;
            card.dataset.wtpbState = 'complete';
            button.textContent = copy.skipped;
            button.disabled = true;
            const following = candidates(root)[0];
            announce(copy.success + (following ? ' ' + fill(copy.next_after_skip,following.label) : ''));
            review.hidden = false;
          } else if (pending.sawLoading && !pending.target.classList.contains('seal-loading')) {
            fail(copy.unconfirmed);
          }
          return;
        }
        if (completed || uncertain) return;
        const candidate = candidates(root)[0];
        if (dialog.open && (!candidate || !selected || candidate.id !== selected.id || candidate.rawTime !== selected.rawTime || candidate.label !== selected.label)) {
          closeDialog();
          announce(copy.changed);
        }
        card.hidden = !candidate;
        card.dataset.wtpbState = candidate ? 'ready' : 'unavailable';
        button.disabled = !candidate;
        if (candidate) next.textContent = fill(copy.next_order,candidate.label);
      };
      const observer = new MutationObserver(mutations => {
        if (!mutations.some(mutation => !card.contains(mutation.target))) return;
        if (!scheduled) {
          scheduled = true;
          requestAnimationFrame(() => { scheduled = false;refresh(); });
        }
      });
      observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-billing-attempt-skip','data-billing-attempt-id','data-billing-attempt-in-the-future','data-billing-attempt-status','class','style','disabled','aria-disabled','data-time','data-id']});
      button.addEventListener('click',() => {
        if (pending || completed || uncertain) return;
        selected = candidates(root)[0];
        if (!selected) { refresh();return; }
        dialogTitle.textContent = fill(copy.confirm_title,selected.label);
        dialogDescription.textContent = copy.confirm_description;
        confirm.disabled = false;
        dialog.showModal();
      });
      keep.addEventListener('click',closeDialog);
      dialog.addEventListener('cancel',() => { selected = null; });
      confirm.addEventListener('click',() => {
        if (!selected || pending || completed || uncertain) return;
        const fresh = candidates(root)[0];
        if (!fresh || fresh.id !== selected.id || fresh.rawTime !== selected.rawTime || fresh.label !== selected.label || fresh.row !== selected.row || fresh.target !== selected.target) { fail(copy.changed);return; }
        pending = fresh;
        card.dataset.wtpbState = 'pending';
        confirm.disabled = true;
        button.disabled = true;
        announce(copy.working);
        closeDialog();
        const operation = pending;
        try { operation.target.click(); } catch (_) { fail(copy.unconfirmed);return; }
        operation.sawLoading = operation.target.classList.contains('seal-loading');
        timeout = setTimeout(() => { if (pending === operation) fail(copy.unconfirmed); },20000);
        refresh();
      });
      review.addEventListener('click',() => {
        const schedule = root.querySelector('.seal-billing-attempts') || root.querySelector(rowSelector);
        if (schedule) schedule.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      });
      refresh();
    });
  };
  document.addEventListener('sealsubs_portal:loaded',mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount,{once:true});
  else mount();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtpb-trustreviews-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const openProductReviews = (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element)) return;
      const rating = event.target.closest('.tr-collection-product-rating');
      if (!rating || !rating.dataset.trProductUrl) return;
      const target = new URL(rating.dataset.trProductUrl, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.hash = 'trustreviewsFrame';
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(target.href);
    };
    document.addEventListener('click', openProductReviews, true);
    document.addEventListener('keydown', openProductReviews, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtx-case-planner"] && !Shopify.designMode) return;
  try {
    (()=>{
 const planner=document.querySelector('[data-case-planner]');
 if(!planner)return;
 const amount=planner.querySelector('[data-daily-amount]');
 const unit=planner.querySelector('[data-daily-unit]');
 const duration=planner.querySelector('[data-plan-days]');
 const cards=[...document.querySelectorAll('[data-wtx-order-card]')];
 const number=new Intl.NumberFormat(document.documentElement.lang||'en-US',{maximumFractionDigits:1});
 const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:planner.dataset.currency||'USD'});
 const words=(key,values)=>Object.entries(values).reduce((text,[name,value])=>text.replaceAll('{'+name+'}',value),planner.dataset[key]);
 const daily=()=>{const n=Number(amount.value);return amount.validity.valid&&n>0?n/(unit.value==='oz'?16:1):0;};
 const caseWeight=option=>{const match=option?.dataset.caseTitle?.match(/^\s*(\d+(?:\.\d+)?)\s*(?:lbs?|pounds?)\b/i);return match?Number(match[1]):0;};
 const update=()=>{
  const perDay=daily(),days=Number(duration.value);
  planner.querySelector('[data-plan-summary]').textContent=perDay?words('total',{weight:number.format(perDay*days),days}):planner.dataset.empty;
  cards.forEach(card=>{
   const form=card.querySelector('form'),option=form.elements.variant.selectedOptions[0];
   const pounds=caseWeight(option),count=Number(form.elements.wtx_quantity.value),box=card.querySelector('[data-case-coverage]');
   const valid=perDay>0&&pounds>0&&Number.isInteger(count)&&count>0&&count<=99;
   box.hidden=!valid;if(!valid)return;
   box.querySelector('[data-case-summary]').textContent=words('coverage',{count,weight:number.format(pounds*count),days:number.format(pounds*count/perDay)});
   box.querySelector('[data-case-cost]').textContent=words('cost',{cost:money.format(Number(option.dataset.price)/100/pounds*perDay)});
   const suggested=Math.ceil(perDay*days/pounds),button=box.querySelector('[data-plan-quantity]');
   button.disabled=suggested>99||option.disabled;
   button.textContent=suggested>99?planner.dataset.limit:words('use',{count:suggested,days,case_label:suggested===1?planner.dataset.caseSingle:planner.dataset.casePlural});
  });
 };
 planner.addEventListener('input',update);planner.addEventListener('change',update);
 cards.forEach(card=>{
  const form=card.querySelector('form');form.addEventListener('input',update);form.addEventListener('change',update);
  card.querySelector('[data-plan-quantity]').addEventListener('click',()=>{
   const pounds=caseWeight(form.elements.variant.selectedOptions[0]);
   const count=Math.ceil(daily()*Number(duration.value)/pounds);
   if(!pounds||count<1||count>99)return;
   form.elements.wtx_quantity.value=String(count);
   form.elements.wtx_quantity.dispatchEvent(new Event('input',{bubbles:true}));
  });
 });update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtx-first-bowl"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-wtx-film]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const videos=root.querySelectorAll('video');root.querySelectorAll('[data-chapter]').forEach(button=>button.addEventListener('click',()=>{videos.forEach(video=>video.pause());root.querySelectorAll('[data-chapter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));root.querySelectorAll('[data-film-panel]').forEach(panel=>panel.hidden=panel.dataset.filmPanel!==button.dataset.chapter);}));videos.forEach(video=>video.addEventListener('play',()=>{videos.forEach(other=>{if(other!==video)other.pause();});}));});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtx-route-calendar"] && !Shopify.designMode) return;
  try {
    (() => {
  const routeKeys = ['dfw', 'basin', 'north', 'nm', 'local'];
  const central = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const display = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
  const localDisplay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
  const timeDisplay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit' });
  const validISO = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const date = new Date(`${value}T12:00:00Z`);
    return !Number.isNaN(date.valueOf()) && date.toISOString().slice(0, 10) === value;
  };
  const validTime = value => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value || '');
  const calculate = (runs, now = new Date()) => {
    const parts = Object.fromEntries(central.formatToParts(now).map(part => [part.type, part.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const clock = `${parts.hour}:${parts.minute}`;
    const processed = runs.map(run => {
      const validDates = Object.fromEntries(routeKeys.filter(key => validISO(run.dates?.[key])).map(key => [key, run.dates[key]]));
      const remaining = Object.values(validDates).filter(date => date >= today).sort();
      const serviceDates = Object.values(validDates).sort();
      const cutoffValid = validISO(run.cutoff) && validTime(run.cutoffTime) && (!serviceDates.length || run.cutoff <= serviceDates[0]);
      const cutoffState = !cutoffValid ? 'unknown' : today > run.cutoff || (today === run.cutoff && clock >= run.cutoffTime) ? 'passed' : 'open';
      return { ...run, validDates, remaining, cutoffState };
    });
    const confirmed = processed.filter(run => run.status === 'confirmed');
    const active = confirmed.filter(run => run.remaining.length).sort((a, b) => a.remaining[0].localeCompare(b.remaining[0]))[0];
    const futureByRoute = Object.fromEntries(routeKeys.map(key => [key, confirmed.filter(run => run.validDates[key] >= today).map(run => ({ date: run.validDates[key], cutoffState: run.cutoffState, runId: run.id })).sort((a, b) => a.date.localeCompare(b.date))]));
    return { today, clock, activeId: active?.id || null, runs: processed, futureByRoute };
  };
  const root = () => document.querySelector('[data-wtx-calendar]');
  const readRuns = calendar => Array.from(calendar.querySelectorAll('[data-wtx-run]')).map(element => ({
    id: element.dataset.runId, status: element.dataset.status, cutoff: element.dataset.cutoff, cutoffTime: element.dataset.cutoffTime,
    dates: Object.fromEntries(Array.from(element.querySelectorAll('[data-wtx-route-date]')).map(time => [time.dataset.wtxRouteDate, time.getAttribute('datetime')]))
  }));
  const dateText = iso => display.format(new Date(`${iso}T12:00:00Z`));
  const localDeliveries = (runs, now = new Date()) => {
    const state = calculate(runs, now);
    const seen = new Set();
    return state.futureByRoute.local.filter(item => {
      if (seen.has(item.date)) return false;
      seen.add(item.date);
      return true;
    }).slice(0, 2).map(item => {
      const run = state.runs.find(candidate => candidate.id === item.runId);
      return { ...item, dateLabel: localDisplay.format(new Date(`${item.date}T12:00:00Z`)), cutoff: run.cutoff, cutoffTime: run.cutoffTime };
    });
  };
  const routeDates = key => {
    const calendar = root();
    if (!calendar) return '';
    const state = calculate(readRuns(calendar));
    const dates = state.futureByRoute[key] || [];
    if (!dates.length) return calendar.dataset.datesUnconfirmed;
    return [...new Set(dates.map(item => {
      const suffix = item.cutoffState === 'passed' ? calendar.dataset.cutoffSuffix : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknownSuffix : '';
      return `${dateText(item.date)}${suffix ? ` (${suffix})` : ''}`;
    }))].join(' · ');
  };
  let selectedRoute = 'all';
  const nextDelivery = (runs, key, now = new Date()) => {
    const state = calculate(runs, now);
    const item = state.futureByRoute[key]?.[0];
    if (!item) return null;
    const run = state.runs.find(candidate => candidate.id === item.runId);
    return { ...item, cutoff: run.cutoff, cutoffTime: run.cutoffTime };
  };
  const showNext = () => {
    const calendar = root(), panel = document.querySelector('[data-wtx-route-next]');
    if (!calendar || !panel) return;
    panel.hidden = selectedRoute === 'all';
    if (panel.hidden) return;
    const button = Array.from(document.querySelectorAll('.wtx-route-filter')).find(item => item.dataset.route === selectedRoute);
    panel.style.setProperty('--route-color', button?.style.getPropertyValue('--route-color') || 'var(--gold)');
    panel.querySelector('[data-wtx-next-name]').textContent = button?.textContent.trim() || '';
    const item = nextDelivery(readRuns(calendar), selectedRoute);
    const date = panel.querySelector('[data-wtx-next-date]'), cutoff = panel.querySelector('[data-wtx-next-cutoff]'), note = panel.querySelector('[data-wtx-next-note]');
    const help = panel.querySelector('[data-wtx-next-help]'), details = panel.querySelector('[data-wtx-next-details]');
    help.hidden = Boolean(item && item.cutoffState === 'open');
    details.hidden = !item;
    if (!item) {
      date.textContent = calendar.dataset.nextEmpty;
      cutoff.textContent = '';
      note.textContent = selectedRoute === 'frontier' ? calendar.dataset.nextFrontier : '';
      return;
    }
    date.textContent = `${calendar.dataset.nextLabel}: ${localDisplay.format(new Date(`${item.date}T12:00:00Z`))}`;
    cutoff.textContent = item.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : `${calendar.dataset.orderBy} ${dateText(item.cutoff)} · ${timeDisplay.format(new Date(`2000-01-01T${item.cutoffTime}:00Z`))} ${calendar.dataset.central}`;
    const runElement = Array.from(calendar.querySelectorAll('[data-wtx-run]')).find(element => element.dataset.runId === item.runId);
    note.textContent = [runElement?.dataset.publicLabel, selectedRoute === 'nm' ? calendar.dataset.nextNm : ''].filter(Boolean).join(' · ');
    details.href = `#wtx-run-${item.runId}`;
  };
  const selectRoute = key => { selectedRoute = key; showNext(); };
  const refresh = () => {
    const calendar = root();
    if (!calendar) return;
    const state = calculate(readRuns(calendar));
    const shouldOpen = calendar.dataset.currentDay !== state.today;
    const elements = Array.from(calendar.querySelectorAll('[data-wtx-run]'));
    for (const run of state.runs) {
      const element = elements.find(item => item.dataset.runId === run.id);
      if (!element) continue;
      if (shouldOpen) element.open = run.id === state.activeId;
      element.dataset.completed = String(run.status === 'confirmed' && !run.remaining.length);
      if (run.status !== 'confirmed') continue;
      const label = element.querySelector('[data-wtx-run-label]');
      if (label) label.textContent = run.remaining.length ? (element.dataset.publicLabel || calendar.dataset.confirmed) : calendar.dataset.archive;
      const status = element.querySelector('[data-wtx-cutoff-status]');
      if (status) status.textContent = run.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : run.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : '';
      const help = element.querySelector('[data-wtx-cutoff-help]');
      if (help) help.hidden = run.cutoffState === 'open';
    }
    if (shouldOpen) {
      const upcoming = state.runs.filter(run => run.status === 'confirmed' && run.remaining.length).sort((a, b) => a.remaining[0].localeCompare(b.remaining[0]));
      const privateRuns = state.runs.filter(run => run.status !== 'confirmed');
      const completed = state.runs.filter(run => run.status === 'confirmed' && !run.remaining.length);
      const list = calendar.querySelector('.wtx-months');
      if (list) [...upcoming, ...privateRuns, ...completed].forEach(run => {
        const element = elements.find(item => item.dataset.runId === run.id);
        if (element) list.appendChild(element);
      });
    }
    const empty = calendar.querySelector('[data-wtx-empty]');
    if (empty) empty.hidden = Boolean(state.activeId);
    calendar.dataset.currentDay = state.today;
    showNext();
    const localDates = localDeliveries(readRuns(calendar));
    document.querySelectorAll('[data-wtx-local-dates]').forEach(wrapper => {
      ['[data-wtx-local-next]', '[data-wtx-local-following]'].forEach((selector, index) => {
        const card = wrapper.querySelector(selector);
        if (!card) return;
        const item = localDates[index];
        card.hidden = !item;
        if (!item) return;
        const date = card.querySelector('[data-wtx-local-date]');
        if (date) {
          date.textContent = item.dateLabel;
          date.setAttribute('datetime', item.date);
        }
        const cutoff = card.querySelector('[data-wtx-local-cutoff]');
        if (cutoff) cutoff.textContent = item.cutoffState === 'passed' ? calendar.dataset.cutoffPassed : item.cutoffState === 'unknown' ? calendar.dataset.cutoffUnknown : `${calendar.dataset.orderBy} ${dateText(item.cutoff)} · ${timeDisplay.format(new Date(`2000-01-01T${item.cutoffTime}:00Z`))} ${calendar.dataset.central}`;
        const help = card.querySelector('[data-wtx-local-help]');
        if (help) help.hidden = item.cutoffState === 'open';
      });
      const localEmpty = wrapper.querySelector('[data-wtx-local-empty]');
      if (localEmpty) localEmpty.hidden = Boolean(localDates.length);
    });
  };
  const hasUpcoming = key => { const calendar = root(); return Boolean(calendar && calculate(readRuns(calendar)).futureByRoute[key]?.length); };
  window.wtxRouteCalendar = { calculate, routeDates, refresh, hasUpcoming, localDeliveries, nextDelivery, selectRoute };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-wtx-next-details]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target) target.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:block:select', event => {
    const calendar = root();
    if (!calendar) return;
    const selected = Array.from(calendar.querySelectorAll('[data-wtx-run]')).find(element => element.dataset.runId === event.detail?.blockId);
    if (selected) selected.open = true;
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.setInterval(() => { if (!document.hidden) refresh(); }, 60000);
})();
  } catch(e) { console.error(e); }
})();

})();
